import { useCallback, useMemo } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { Group, GroupID } from '@playq/octopus2-admin';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const groupGetKeys: unknown[] = ['admin', 'group', 'get'];

export const useGroupGet = (
  id?: GroupID,
  options?: IUseQueryOptionsExtended<Group | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => groupGetKeys.concat(id), [id]);

  const { mutate, ...res } = useEitherQuery(keys, () => services2.adminGroupsService.retrieve(id as GroupID), {
    placeholderData: keepPreviousData,
    ...options,
    enabled: options?.enabled !== false && id !== undefined,
  });

  const mutateDeletedGroup = useCallback(
    (group: Group) => {
      if (res.data) {
        mutate(group);
      }
    },
    [mutate, res.data]
  );

  return {
    group: res.data,
    ...res,
    tags: keys,
    mutate,
    mutateDeletedGroup,
  };
};
